import Head from "next/head";

import NewselaGlobalLayout from "@/base";
import PasswordResetPage from "@/login/PasswordResetPage/PasswordResetPage";

const PasswordResetPageRoute = () => (
  <>
    <Head>
      <title>Newsela | Reset Your Password</title>
    </Head>
    <NewselaGlobalLayout mainContents={<PasswordResetPage />} />
  </>
);

export default PasswordResetPageRoute;
